<section class="upcoming-bootcamps-area ptb-100 bg-fafafb">
    <div class="container">
        <div class="upcoming-bootcamps-content" *ngFor="let Content of bootcampsContent;">
            <h2>{{Content.title}}</h2>
            <a routerLink="/{{Content.defaultBtnLink}}" class="default-btn"><i class="{{Content.defaultBtnIcon}}"></i>{{Content.defaultBtnText}}<span></span></a>
        </div>
    </div>
</section>